import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faKey, faUserLock, faLock } from '@fortawesome/pro-regular-svg-icons';

const AUTH_TYPE_ICON_MAP: { [key: string]: IconDefinition } = {
  key: faKey,
  'user-lock': faUserLock,
  lock: faLock,
};

export const getAuthTypeIcon = (iconKey: string): IconDefinition =>
  AUTH_TYPE_ICON_MAP[iconKey] || faKey;

// Helper function to extract metadata values as strings, ignoring object-type values
export const getMetadataSearchString = (metadata?: Record<string, unknown>): string => {
  if (!metadata) {
    return '';
  }

  // Extract all values from metadata object
  return Object.values(metadata)
    .filter(
      (value) =>
        // Filter out null, undefined, and object-type values
        value !== null && value !== undefined && typeof value !== 'object',
    )
    .map((value) => String(value)) // Convert remaining values to strings
    .join(' '); // Join them into a single searchable string
};
